// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c043b20","453":"fa37fcf8","732":"ce808873","977":"d61e6a71"}[chunkId] + ".chunk.js";
};